import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink/ExternalLink';
import { WizardStep } from '@/components/Wizard';
import { CONTACT_US_URL } from '@/constants';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';
import { selectResources } from '@/reducers/common/selectors';

import styles from './ClaimBookingStep.module.scss';

type ClaimImportErrorProps = {
  tabId: string;
  connectBooking: () => void;
};

const ClaimImportError: React.FC<ClaimImportErrorProps> = ({ tabId, connectBooking }) => {
  const appUiData = useAppUiData();
  const resources = useSelector(selectResources);
  return (
    <WizardStep tabId={tabId}>
      <h2 className={styles.title}>{appUiData[appUiIds.importation.thatsAwkward]}</h2>
      <p className={styles.subtitle}>{appUiData[appUiIds.importation.tryAgainText]}</p>
      <Button variant="payment-card" onClick={connectBooking} className={styles.buttonConnectBooking}>
        {appUiData[appUiIds.importation.connectBooking]}
      </Button>
      <div className={styles.linkContainer}>
        <ExternalLink href={resources[CONTACT_US_URL] as string} name={appUiData[appUiIds.sailorServices]} />
      </div>
    </WizardStep>
  );
};

export default ClaimImportError;
